module.exports = __webpack_public_path__ + "assets/img/AnnouncementBAPC.91375815.png";